import * as ss from 'superstruct';

export const SortOrder = ss.enums(['ASC', 'DESC']);

export type SortOrder = ss.Infer<typeof SortOrder>;
